import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default class LightTile extends React.Component {

    constructor(props) {
        super(props);
        this.state = { tileclass: 'light-tile-container', imgUrl: ''};
        this.tileClassHover = this.tileClassHover.bind(this);
        this.tileClassNormal = this.tileClassNormal.bind(this);
        console.log(this.props)
    }

    tileClassHover(){
        this.setState({ tileclass: 'light-tile-container-hover'})
    }

    tileClassNormal(){
        this.setState({ tileclass: 'light-tile-container'})
    }

    conditionalRefresh(){
        if(window.location.href.indexOf("singlepost")){
            return this.forceUpdate;
        }
    }

    componentDidMount() {
        const{ featured_media } = this.props.book;
        axios.get('https://theallfathersdomain.000webhostapp.com/wp-json/wp/v2/media/'+featured_media)
            .then(
                res => {
                    this.setState({ imgUrl: res.data.media_details.sizes.full.source_url })
                }
            )
            .catch(err => console.log(err))
    }

    render(){
        const { id, title, excerpt } = this.props.book;

        return(
            <div onMouseEnter={this.tileClassHover} onMouseLeave={this.tileClassNormal} className={this.state.tileclass}>
                <div className="light-tile-image"><img src={this.state.imgUrl} /></div>
                <div className="light-tile-text">
                    <h2>{title.rendered}</h2>
                    <div dangerouslySetInnerHTML={{__html: excerpt.rendered}}/>
                    <button><Link  onClick={this.conditionalRefresh} to={'/singlepost/'+id}>Read More</Link></button>
                </div>
            </div>
        )
    }
}